import React from 'react';
import "../App.css"
import { Container } from '../style';
import { useTranslation } from 'react-i18next';


const ForceTask = () => {
    const { t } = useTranslation();

    return (
        <Container>
            <br/>
            <br/>
            <br/>
            <section className="club-info">
        <h2 className="club-info__title">{t('clubInfo.title')}</h2>
        <div className="club-info__text">
          {t('clubInfo.description', { returnObjects: true }).map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section className="regulations">
        <h2 className="regulations__title">{t('regulations.title')}</h2>

        {Object.keys(t('regulations.sections', { returnObjects: true })).map((sectionKey) => (
          <div key={sectionKey} className="regulations__section">
            <h3 className="regulations__section-title">
              {t(`regulations.sections.${sectionKey}.title`)}
            </h3>
            {['general', 'membership', 'organization'].includes(sectionKey) ? (
              <div className="regulations__text">
                {t(`regulations.sections.${sectionKey}.items`, { returnObjects: true }).map((item, index) => (
                  <p key={index}>{item}</p>
                ))}
              </div>
            ) : (
              <ul className="regulations__list">
                {t(`regulations.sections.${sectionKey}.items`, { returnObjects: true }).map((item, index) => (
                  <li key={index} className="regulations__list-item">{item}</li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </section>
            <br/>
            <br/>
            <br/>
        </Container>
    );
}

export default ForceTask;
